import { esFechaIso, lunesDe } from './semanas';

/**
 * Rutas del módulo en el admin (decisión propia del plan v2):
 *
 *   /metas/captura | autorizacion | pendientes | alcances | accesos
 *   ?semana=AAAA-MM-DD&tienda=VAZ-1
 *
 * La pestaña sale de la ruta y la semana y la tienda de los parámetros, para
 * que un enlace se pueda compartir. `/metas` a secas (los enlaces viejos)
 * lleva a la primera pestaña que la cuenta puede ver.
 */
export type Pestana = 'captura' | 'autorizacion' | 'pendientes' | 'alcances' | 'accesos';

export const RUTA_BASE = '/metas';

const PESTANAS: Pestana[] = ['captura', 'autorizacion', 'pendientes', 'alcances', 'accesos'];

export const esPestana = (s: unknown): s is Pestana => typeof s === 'string' && (PESTANAS as string[]).includes(s);

export const rutaPestana = (p: Pestana): string => `${RUTA_BASE}/${p}`;

/** La pestaña de un `pathname` (`/metas/autorizacion/…` → `autorizacion`); `null` si no hay o no existe. */
export function pestanaDeRuta(pathname: string): Pestana | null {
  const resto = pathname.startsWith(`${RUTA_BASE}/`) ? pathname.slice(RUTA_BASE.length + 1) : '';
  const seg = resto.split('/')[0];
  return esPestana(seg) ? seg : null;
}

/**
 * `?semana=` → el LUNES de esa semana (se acepta cualquier día y se lleva a su
 * lunes). `null` si no es una fecha real.
 */
export function leerSemanaParam(v: string | null | undefined): string | null {
  if (!esFechaIso(v)) return null;
  return lunesDe(v);
}

export interface TiendaParam {
  chain: string;
  num: number;
}

/**
 * `?tienda=` → cadena y número. Acepta `VAZ-1` (lo que escribimos), `VAZ1`
 * (el formato de la SPEC), `VAZ 1` y minúsculas.
 */
export function leerTiendaParam(v: string | null | undefined): TiendaParam | null {
  const m = /^\s*([A-Za-z]+)[\s-]?(\d+)\s*$/.exec(v ?? '');
  if (!m) return null;
  const num = Number(m[2]);
  if (!Number.isSafeInteger(num)) return null;
  return { chain: m[1].toUpperCase(), num };
}

export const tiendaParam = (t: TiendaParam): string => `${t.chain}-${t.num}`;
